import { useState } from "react";
import { useDispatch } from "react-redux";
import { Box, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { useMutation } from "@apollo/client";
import { OrderKit } from "../../../apollo-client/api-query";
import BaseButton from "../../BaseButton";
import { closeModal } from "../../../store";

const FirstModal = ({isLoading, handleClick}) => (
    <Box sx={{
    }}>
        {/* Title */}
        <Box>
            <Typography 
                sx={{
                    color: '#5A3BC7'
                }}
                variant="h1"
            >Order more kits</Typography>
            <Typography
                sx={{
                    color: '#5B87EF'
                }}
                variant="subText"
            >The kits will be sent to your Clinic Address on file</Typography>
        </Box>
        {/* Description */}
        <Typography mt={3} variant="h2" color="primary.black">
            Click yes to place an order of 5 kits
        </Typography>
        <Box 
            sx={{
                display: 'flex',
                justifyContent: 'space-between'
            }}
            mt={3}
        >
            <BaseButton 
                sx={{
                    width: '152px',
                    borderRadius: '100px',
                    background: '#46545F',
                    '&:hover': {
                        background: '#46545F',
                    }
                }}
                onClick={() => handleClick(2)}
            >
                Cancel
            </BaseButton>
            <BaseButton 
                sx={{
                    width: '152px',
                    borderRadius: '100px',
                    background: 'linear-gradient(82.43deg, #5A3BC7 7.57%, #5B87EF 88.27%)',
                }}
                onClick={() => handleClick(1)}
                loading={isLoading}
            >
                Yes
            </BaseButton>
        </Box>
    </Box>
)

const SecondModal = ({handleClick}) => (
    <Box>
        <Typography 
            sx={{
                color: '#5A3BC7'
            }}
            variant="h1"
        >
            Order request sent
        </Typography>
        <Typography variant="h4" color="primary.black" mt={3}>
            Your request has been sent!
        </Typography>
        <Typography variant="h4" color="primary.black" mt={4}>
            Please allow us 1 week to deliver the order. We will ship to your clinic address in your profile.
        </Typography>
        <BaseButton 
            sx={{
                width: '100%',
                borderRadius: '100px',
                background: 'linear-gradient(82.43deg, #5A3BC7 7.57%, #5B87EF 88.27%)',
                marginTop: '24px'
            }}
            onClick={handleClick}
        >
            Close this window
        </BaseButton>
    </Box>
)

export default function OrderKitModal() {
    const dispatch = useDispatch();
    const [step, setStep] = useState(1);
    const [isLoadingFirstModal, setIsLoadingFirstModal] = useState(false)
    const [orderKit] = useMutation(OrderKit);
    const handleFirstModalClick = async (type) => {
        if(type === 1) {
            setIsLoadingFirstModal(true)
            try {
                await orderKit()
            } catch (e) {

            }
            setIsLoadingFirstModal(false)
            setStep(2)
        } else {
            handleCloseModal()
        }
    }

    const handleCloseModal = () => {
        dispatch(
            closeModal()
        )
    }

    return (
        <Box sx={{
            position: 'relative',
            width: '478px',
            borderRadius: '16px',
            background: 'white',
            padding: '40px 32px'
        }}>
        {step === 1 ?
            <FirstModal handleClick={handleFirstModalClick} isLoading={isLoadingFirstModal}/>
            :
            <SecondModal handleClick={handleCloseModal}/>
        }
            <Box 
                sx={{
                    position: 'absolute',
                    right: '22px',
                    top: '22px',
                    cursor: 'pointer'
                }}
                onClick={handleCloseModal}
            >
                <CloseIcon width={32} height={32}/>
            </Box>
        </Box>
    )
}
